/*
 * Per-deployment branding: the one brokerage this build serves.
 *
 * Onboarding a new client means editing this file and replacing the logos in public/client/.
 * Nothing else in src/ names a client. See docs/onboard-client.md.
 */

export interface ClientBrand {
  /** Full legal or trading name, for the sign-in screen and About. */
  companyName: string;
  /** Short name for the sidebar and browser tab titles. */
  shortName: string;
  logo: {
    /** For light surfaces (sign-in form). */
    onLight: string;
    /** For the charcoal rail. */
    onDark: string;
  };
  contact?: { phone?: string; email?: string; address?: string; website?: string };
}

/* Placeholder client for development and demos. Replace per deployment. */
export const client: ClientBrand = {
  companyName: "Demo Realty",
  shortName: "Demo Realty",
  logo: {
    onLight: "/client/logo-on-light.svg",
    onDark: "/client/logo-on-dark.svg",
  },
  contact: {
    phone: "+20 10 0000 0000",
    email: "sales@demo-realty.example.com",
    address: "New Cairo, Egypt",
  },
};
